import script from "./DepartmentUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentUserForm.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentUserForm.vue?vue&type=style&index=0&id=75d240e9&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d240e9"]])

export default __exports__